<template>
  <div class="NoAuthentication" v-if="showDialog">
    <div class="icon-box" style="z-index:2019">
      <div class="icon">
        <img src="../../assets/images/search/bg_auth_tip.png" alt="" srcset="">
      </div>
    </div>
    <van-popup v-model="showDialog">
      <div class="content">
        <div class="title">认证后继续查询</div>
        <div class="message">您可以选择个人认证<span>(送10票)</span>或企业</div>
        <div class="message">认证<span>(送20票)</span></div>
        <div class="btn-box flex">
          <div class="btn" @click="goAuthentication(1)">个人认证</div>
          <div class="btn" @click="goAuthentication(2)">企业认证</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { wxNavigateTo } from '../../utils/WeChatUtil'
export default {
  props: {},
  data() {
    return {
      showDialog: false
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    /**
     * 显示弹框
    */
    showPopup () {
      this.showDialog = true
    },
    goAuthentication (type) {
      this.showDialog = false
      if (this.isWechart) {
        console.log(this.$store.state)
        const user_id = this.$store.state.userInfo.user_content.userId
        if (type === 1) {
          wxNavigateTo(`../user/auth/person?userId=${user_id}`)
        } else {
          wxNavigateTo(`../user/auth/company?redirectUrl=https://proxy.yunlsp.com/sso/weChat/forwardByUnionId&params=${encodeURIComponent(`?type=9&id=${user_id}`)}&userId=${user_id}`)
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.NoAuthentication>:nth-child(2) {
  background-color: rgba(0,0,0,.4)
}
.NoAuthentication>:nth-child(3) {
  border-radius: 12px;
  width: 80%
}
.NoAuthentication {
  .icon-box {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 2019;
    margin-left: -75px;
    margin-top: -260px;
    .icon {
      text-align: center;
      img {
        width: 150px;
      }
    }
  }
  .title {
    text-align: center;
    font-weight: bold;
    padding-top: 10px;
  }
  .content {
    padding: 30px 30px;
    padding-top: 60px;
    .message {
      padding: 10px 0;
      span {
        color: #FF3C3C
      }
    }
    .btn-box {
      justify-content: space-between;
      margin-top: 20px;
      .btn {
        flex: .45;
        height: 80px;
        line-height: 80px;
        text-align: center;
        border-radius: 3px;
        color: #ffffff;
        background-color: #5572FD;
      }
    }
  }
}
</style>
